import React from "react";
import bild4 from "../bilder/hero-umzug-transporter.png";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto grid max-w-[1100px] items-center gap-8 px-4 py-10 md:grid-cols-2 md:py-16">
        <div>
          <h1 className="mt-3 text-3xl font-extrabold tracking-tight md:text-5xl">
            Umzug günstig, schnell & zuverlässig
          </h1>
          <p className="mt-3 text-slate-600">
            Erfahrene Helfer mit und ohne Transporter – kurzfristig verfügbar, versichert und fair bepreist.
          </p>

          <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
            <a href="#kontakt" className="rounded-xl bg-[#FF6B00] px-5 py-4 text-center font-semibold text-white">
              Angebot anfordern
            </a>
            <a href="tel:+4917641011065" className="rounded-xl border border-[#FF6B00] px-5 py-4 text-center font-semibold text-[#FF6B00]">
              Jetzt anrufen
            </a>
          </div>

          <ul className="mt-5 grid grid-cols-1 gap-2 text-sm text-slate-600 sm:grid-cols-2">
            <li>✔️ Umzug</li>
            <li>✔️ Möbelmontage</li>
            <li>✔️ Demontage & Transport</li>
            <li>✔️ Schnell — Sicher — Preiswert</li>
            <li>✔️ Studentische Umzugshelfer</li>
          </ul>
        </div>

        <div className="relative">
          <div
            style={{ backgroundImage: `url(${bild4})` }}
            className="aspect-video w-full rounded-3xl bg-cover bg-center shadow-inner"
            aria-label="Umzugstransporter und Kartons"
          />
          <div className="absolute -bottom-5 -left-5 rotate-[-2deg] rounded-2xl bg-white p-3 text-sm shadow-lg">
            🛡️ Umzugsgut versichert
          </div>
        </div>
      </div>
    </section>
  );
}
